import { Component, HostListener, OnInit } from "@angular/core";
// Models
import { USER_PERMISSIONS } from "@core/entities";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { environment } from "@environments/environment";
import { AuthService } from "@auth0/auth0-angular";
import { Router } from "@angular/router";
import { localStorageKey } from "@core/constants";
import { GlobalService } from "@core/services/global.services";

interface Menu extends ItemMenu {
  items?: ItemMenu[];
}

type ItemMenu = {
  icon: string;
  text: Observable<string>;
  link?: string;
  isNew?: boolean;
  role?: string[];
  countriesEnable?: Array<string>;
  open?: boolean;
  subItems?: {
    text: Observable<string>;
    role?: string[];
    link: string;
  }[];
};

@Component({
  selector: "app-vertical-menu",
  templateUrl: "./vertical-menu.component.html",
  styleUrls: ["./vertical-menu.component.scss"],
})
export class VerticalMenuComponent implements OnInit {
  administrationMenu: Menu[] = [];
  menuCollapse: boolean;
  menuOptionSelected: boolean = false;
  isVendorUser: boolean = false;
  private hasRedirected: boolean = false;
  private _usersHasAccessToModuleMetrics: boolean = true;
  private allMenuModulesSupplier: Menu[] = [
    {
      icon: "bi bi-house-door",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.HOME"),
      link: "home",
      role: [],
      items: [],
    },
    {
      icon: "bi bi-file-earmark-check",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.ORDERS"),
      role: [
        USER_PERMISSIONS.PURCHASE_ORDERS_ACCESS,
        USER_PERMISSIONS.CONSIGMENT_ORDERS_ACCESS,
      ],
      items: [
        {
          icon: "",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PURCHASE_ORDERS"
          ),
          link: "purchase-orders",
          role: [USER_PERMISSIONS.PURCHASE_ORDERS_ACCESS],
        },
        {
          icon: "",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.CONSIGNMENT_ORDERS"
          ),
          link: "consignment-orders",
          role: [USER_PERMISSIONS.CONSIGMENT_ORDERS_ACCESS],
        },
        {
          icon: "",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PRIORI_SCHEDULE"
          ),
          link: "priori-schedule-supplier",
          role: [USER_PERMISSIONS.SUPPLIER_PRIORI_SCHEDULE_ACCESS],
        },
      ],
    },
    {
      icon: "bi bi-receipt",
      text: this.translateService.get(
        "DASHBOARD.VERTICAL_MENU.MENU.COLLECTION"
      ),
      role: [
        USER_PERMISSIONS.PAYMENTS_ACCESS,
        USER_PERMISSIONS.FRONT_MARGINS_ACCESS,
      ],
      items: [
        {
          icon: "",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.BACK_MARGINS"
          ),
          link: "payment-back-margins",
          role: [USER_PERMISSIONS.PAYMENTS_ACCESS],
        },
        {
          icon: "",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.FRONT_MARGINS"
          ),
          link: "payment-front-margins",
          role: [USER_PERMISSIONS.FRONT_MARGINS_ACCESS],
        },
      ],
    },
    {
      icon: "bi bi-info-circle",
      text: this.translateService.get(
        "DASHBOARD.VERTICAL_MENU.MENU.INFORMATION"
      ),
      link: "supplier-management",
      role: [USER_PERMISSIONS.SUPPLIER_ADMIN_ACCESS],
    },
    {
      icon: "bi bi-file-earmark-check",
      text: this.translateService.get(
        "DASHBOARD.VERTICAL_MENU.MENU.AGREEMENTS"
      ),
      link: "commercial-agreements",
      role: [USER_PERMISSIONS.SUPPLIER_MANAGEMENT_ACCESS],
    },
    {
      icon: "bi bi-bar-chart-line-fill",
      text: this.translateService.get(
        "DASHBOARD.VERTICAL_MENU.MENU.SUPPLIER_METRICS"
      ),
      link: "supplier-metrics",
      role: [USER_PERMISSIONS.SUPPLIER_METRICS_ACCESS],
    },
  ];
  allMenuModules: Menu[] = [
    {
      icon: "bi bi-house-door",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.HOME"),
      link: "home",
      role: [],
      items: [],
    },
    {
      icon: "bi bi-journal-bookmark",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.ORDERS"),
      role: [
        USER_PERMISSIONS.FAKEORDER_ACCESS,
        USER_PERMISSIONS.REALTIME_FAKE_ORDERS_ACCESS,
        USER_PERMISSIONS.CONTROL_PANEL_ACCESS,
        USER_PERMISSIONS.ORDER_TRACKING_ACCESS,
        USER_PERMISSIONS.CARGO_INVOICE,
        USER_PERMISSIONS.ACCURACY_TRACKER_ACCESS,
        USER_PERMISSIONS.POS_ACCESS,
        USER_PERMISSIONS.SALE_INVOICE_ACCESS,
      ],
      items: [
        {
          icon: "bi bi-file-earmark-arrow-down",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.SALES_ORDERS"
          ),
          link: "query-invoices",
          role: [USER_PERMISSIONS.SALE_INVOICE_ACCESS],
        },
        {
          icon: "bi bi-list-task",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.FAKE_ORDERS"
          ),
          link: "fake-orders",
          role: [USER_PERMISSIONS.FAKEORDER_ACCESS],
        },
        {
          icon: "bi bi-clock",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.REALTIME_FO"
          ),
          link: "realtime-fo",
          role: [USER_PERMISSIONS.REALTIME_FAKE_ORDERS_ACCESS],
        },
        {
          icon: "bi bi-calendar2-event",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.CONTROL_PANEL"
          ),
          link: "control-panel",
          role: [USER_PERMISSIONS.CONTROL_PANEL_ACCESS],
        },
        {
          icon: "bi bi-list-check",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.ACTIVE_ORDERS"
          ),
          link: "order-tracking",
          role: [USER_PERMISSIONS.ORDER_TRACKING_ACCESS],
        },
        {
          icon: "bi bi-bullseye",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.ACCURACY_TRACKER"
          ),
          link: "accuracy-tracker",
          role: [USER_PERMISSIONS.ACCURACY_TRACKER_ACCESS],
        },
        {
          icon: "bi bi-receipt",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.CARGO_INVOICE"
          ),
          link: "cargo-invoice",
          role: [USER_PERMISSIONS.CARGO_INVOICE],
        },
        {
          icon: "bi bi-file-post",
          text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.POS"),
          link: "pos",
          role: [USER_PERMISSIONS.POS_ACCESS],
          countriesEnable: ["CL", "CO"],
        },
      ],
    },
    {
      icon: "bi bi-truck",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.VENDORS"),
      role: [
        USER_PERMISSIONS.PRICE_LIST_ACCESS,
        USER_PERMISSIONS.ONBOARDING_ACCESS,
        USER_PERMISSIONS.SELF_ONBOARDING_ACCESS,
        USER_PERMISSIONS.CATMAN_ONBOARDING_ACCESS,
        USER_PERMISSIONS.DATA_MASTER_ONBOARDING_ACCESS,
        USER_PERMISSIONS.SUPPLIER_MANAGEMENT_ACCESS,
        USER_PERMISSIONS.PAYMENTS_ACCESS,
        USER_PERMISSIONS.FRONT_MARGINS_ACCESS,
        USER_PERMISSIONS.PURCHASE_ORDERS_ACCESS,
        USER_PERMISSIONS.CONSIGMENT_ORDERS_ACCESS,
        USER_PERMISSIONS.SUPPLIER_ADMIN_ACCESS,
      ],
      items: [
        {
          icon: "bi bi-card-checklist",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.ORDERS_SUPPLIERS"
          ),
          role: [
            USER_PERMISSIONS.PURCHASE_ORDERS_ACCESS,
            USER_PERMISSIONS.CONSIGMENT_ORDERS_ACCESS,
          ],
          subItems: [
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.PURCHASE_ORDERS"
              ),
              link: "purchase-orders",
              role: [USER_PERMISSIONS.PURCHASE_ORDERS_ACCESS],
            },
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.CONSIGNMENT_ORDERS"
              ),
              link: "consignment-orders",
              role: [USER_PERMISSIONS.CONSIGMENT_ORDERS_ACCESS],
            },
          ],
        },
        // {
        //   icon: "bi bi-list-check",
        //   text: this.translateService.get(
        //     "DASHBOARD.VERTICAL_MENU.MENU.PRICE_LIST"
        //   ),
        //   link: "price-list",
        //   role: [USER_PERMISSIONS.PRICE_LIST_ACCESS],
        // },
        {
          icon: "bi bi-journal-text",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.COMMERCIAL_AGREEMENT"
          ),
          link: "commercial-agreements",
          role: [USER_PERMISSIONS.SUPPLIER_MANAGEMENT_ACCESS],
        },
        {
          icon: "bi bi-person-fill-gear",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.SUPPLIER_MANAGEMENT"
          ),
          link: "supplier-management",
          role: [USER_PERMISSIONS.SUPPLIER_ADMIN_ACCESS],
        },
        {
          icon: "bi bi-cash-coin",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PAYMENTS"
          ),
          role: [
            USER_PERMISSIONS.PAYMENTS_ACCESS,
            USER_PERMISSIONS.FRONT_MARGINS_ACCESS,
          ],
          subItems: [
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.BACK_MARGINS"
              ),
              link: "payment-back-margins",
              role: [USER_PERMISSIONS.PAYMENTS_ACCESS],
            },
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.FRONT_MARGINS"
              ),
              link: "payment-front-margins",
              role: [USER_PERMISSIONS.FRONT_MARGINS_ACCESS],
            },
          ],
        },
        {
          icon: "bi bi-bar-chart-line-fill",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.METRICS"
          ),
          link: "supplier-metrics",
          role: [USER_PERMISSIONS.SUPPLIER_METRICS_ACCESS],
        },
        {
          icon: "bi bi-calendar",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PRIORI_SCHEDULE"
          ),
          link: "priori-schedule-supplier",
          role: [USER_PERMISSIONS.SUPPLIER_PRIORI_SCHEDULE_ACCESS],
        },
      ],
    },
    {
      icon: "bi bi-shop",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.WAREHOUSE"),
      role: [
        USER_PERMISSIONS.WISHLIST_ACCESS,
        USER_PERMISSIONS.PACKS_ACCESS,
        USER_PERMISSIONS.COLD_PRODUCTS_ACCESS,
        USER_PERMISSIONS.BULK_UPLOAD_ACCESS,
        USER_PERMISSIONS.TURBOX_ASSOCIATIONS_ACCESS,
        USER_PERMISSIONS.CATALOG_ACCESS,
        USER_PERMISSIONS.WAREHOUSE_CONFIG_ACCESS,
        USER_PERMISSIONS.PRODUCT_VISIBILITY_ACCESS,
        USER_PERMISSIONS.LABEL_ACCESS,
        USER_PERMISSIONS.ROTATION_MANAGER_ACCESS,
      ],
      items: [
        {
          icon: "bi bi-file-text",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.WISHLIST"
          ),
          link: "wishlist",
          role: [USER_PERMISSIONS.WISHLIST_ACCESS],
        },
        {
          icon: "bi bi-upload",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.BULK_UPLOAD"
          ),
          link: "bulk-upload",
          role: [USER_PERMISSIONS.BULK_UPLOAD_ACCESS],
        },
        {
          icon: "bi bi-graph-up-arrow",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.METRICS_ANALITICS"
          ),
          role: [USER_PERMISSIONS.PRODUCT_VISIBILITY_ACCESS],
          subItems: [
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.PRODUCT_VISIBILITY"
              ),
              role: [USER_PERMISSIONS.PRODUCT_VISIBILITY_ACCESS],
              link: "product-visibility",
            },
          ],
        },
        {
          icon: "bi bi-boxes",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.ASSIGNMENTS"
          ),
          link: "assignments",
          role: [USER_PERMISSIONS.TURBOX_ASSOCIATIONS_ACCESS],
        },
        {
          icon: "bi bi-thermometer-snow",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.COLD_PRODUCTS"
          ),
          link: "cold-products",
          role: [USER_PERMISSIONS.COLD_PRODUCTS_ACCESS],
        },
        {
          icon: "bi bi-list-ol",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.CATALOG"
          ),
          link: "catalog",
          role: [USER_PERMISSIONS.CATALOG_ACCESS],
        },
        {
          icon: "bi bi-basket",
          text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.PACKS"),
          link: "packs",
          role: [USER_PERMISSIONS.PACKS_ACCESS],
        },
        {
          icon: "bi bi-gear-wide",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.WAREHOUSE_CONFIG"
          ),
          link: "warehouse-config",
          role: [USER_PERMISSIONS.WAREHOUSE_CONFIG_ACCESS],
        },
        {
          icon: "bi bi-arrow-repeat",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.ROTATION_MANAGER"
          ),
          role: [USER_PERMISSIONS.ROTATION_MANAGER_ACCESS],
          link: "rotation-mgr",
        },
        {
          icon: "bi bi-tag",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.LABEL_MANAGER"
          ),
          link: "label-manager",
          role: [USER_PERMISSIONS.LABEL_ACCESS],
        },
      ],
    },
    {
      icon: "bi bi-cart",
      text: this.translateService.get(
        "DASHBOARD.VERTICAL_MENU.MENU.MULTIBRAND"
      ),
      role: [USER_PERMISSIONS.MULTIBRAND_ACCESS, USER_PERMISSIONS.STORE_ACCESS],
      items: [
        {
          icon: "bi bi-cart",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.MULTIBRAND"
          ),
          link: "multibrand",
          role: [USER_PERMISSIONS.MULTIBRAND_ACCESS],
        },
        {
          icon: "bi bi-shop-window",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.STORES"
          ),
          link: "store",
          role: [USER_PERMISSIONS.STORE_ACCESS],
        },
      ],
    },
    {
      icon: "bi bi-tags",
      text: this.translateService.get(
        "DASHBOARD.VERTICAL_MENU.MENU.PRICES_MANAGMENT"
      ),
      role: [
        USER_PERMISSIONS.PRICE_MANAGER_ACCESS,
        USER_PERMISSIONS.SELL_PRICES_ACCESS,
        USER_PERMISSIONS.PROMOTION_ACCESS,
        USER_PERMISSIONS.PROMOTION_MARKDOWNS,
        USER_PERMISSIONS.COMPETITIVE_PRICE_ACCESS,
        USER_PERMISSIONS.CHARM_PRICE_ACCESS,
        USER_PERMISSIONS.RESTRICT_LIST_ACCESS,
        USER_PERMISSIONS.MARKUP_ACCESS,
        USER_PERMISSIONS.COMPLEX_DISCOUNT_ACCESS,
        USER_PERMISSIONS.BULK_UPLOAD_ACCESS,
        USER_PERMISSIONS.PRICING_ACCESS,
      ],
      items: [
        {
          icon: "bi bi-currency-dollar",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PRICE_MANAGER"
          ),
          link: "price-manager",
          role: [USER_PERMISSIONS.PRICE_MANAGER_ACCESS],
        },
        {
          icon: "bi bi-calculator",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PRICING"
          ),
          role: [USER_PERMISSIONS.PRICING_ACCESS],
          subItems: [
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.SCENARIOS"
              ),
              link: "pricing/scenario",
              role: [USER_PERMISSIONS.PRICING_ACCESS],
            },
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.STRATEGIES"
              ),
              link: "pricing/strategy",
              role: [USER_PERMISSIONS.PRICING_ACCESS],
            },
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.CLUSTERS"
              ),
              link: "pricing/clusters",
              role: [USER_PERMISSIONS.PRICING_ACCESS],
            },
          ],
        },
        {
          icon: "bi bi-upload",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.BULK_UPLOAD"
          ),
          link: "bulk-upload",
          role: [USER_PERMISSIONS.BULK_UPLOAD_ACCESS],
        },
        {
          icon: "bi bi-patch-plus",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.MARKUP"
          ),
          link: "markup",
          role: [USER_PERMISSIONS.MARKUP_ACCESS],
        },
        {
          icon: "bi bi-tag",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.SELL_PRICING"
          ),
          link: "sell-pricing",
          role: [USER_PERMISSIONS.SELL_PRICES_ACCESS],
        },
        {
          icon: "bi bi-ticket-perforated",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PROMOTION"
          ),
          link: "promotion",
          role: [USER_PERMISSIONS.PROMOTION_MARKDOWNS],
        },
        {
          icon: "bi  bi-percent",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PROMOTIONV2"
          ),
          role: [USER_PERMISSIONS.PROMOTION_ACCESS],
          subItems: [
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.PROMOTIONV2_SIMPLE"
              ),
              link: "promotions-v2/simple",
              role: [USER_PERMISSIONS.PROMOTION_ACCESS],
            },
            {
              text: this.translateService.get(
                "DASHBOARD.VERTICAL_MENU.MENU.PROMOTIONV2_COMPLEX"
              ),
              link: "promotions-v2/complex",
              role: [USER_PERMISSIONS.PROMOTION_ACCESS],
            },
          ],
        },
      ],
    },
    {
      icon: "bi bi-boxes",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.INVENTORY"),
      role: [
        USER_PERMISSIONS.SUPPLY_EXECUTION,
        USER_PERMISSIONS.SUPPLY_INVENTORY_ACCESS,
        USER_PERMISSIONS.SUPPLY_TRANSFORMATIONS_ACCESS,
        USER_PERMISSIONS.CYCLICS_ACCESS,
      ],
      items: [
        {
          icon: "bi bi-hurricane",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.TRANSFORMATIONS"
          ),
          link: "transformations",
          role: [
            USER_PERMISSIONS.SUPPLY_EXECUTION,
            USER_PERMISSIONS.SUPPLY_TRANSFORMATIONS_ACCESS,
          ],
        },
        {
          icon: "bi bi-journal-bookmark",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.INVENTORY"
          ),
          link: "inventory-savvy",
          role: [
            USER_PERMISSIONS.SUPPLY_EXECUTION,
            USER_PERMISSIONS.SUPPLY_INVENTORY_ACCESS,
          ],
        },
        {
          icon: "bi bi-arrow-repeat",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.CYCLICS"
          ),
          link: "cyclics",
          role: [USER_PERMISSIONS.CYCLICS_ACCESS],
        },
      ],
    },
    {
      icon: "bi bi-box-seam",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.SUPPLY"),
      role: [
        USER_PERMISSIONS.SUPPLY_EXECUTION,
        USER_PERMISSIONS.SUPPLY_PURCHASE_ORDER_ACCESS,
        USER_PERMISSIONS.SUPPLY_TRANSFER_ORDERS_ACCESS,
        USER_PERMISSIONS.DC_PRIORI_SCHEDULE_ACCESS,
        USER_PERMISSIONS.RECEPTION_ORDER_ACCESS,
      ],
      items: [
        {
          icon: "bi bi-card-checklist",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.SUPPLY_PURCHASE_ORDERS"
          ),
          link: "supply-purchase-orders",
          role: [
            USER_PERMISSIONS.SUPPLY_EXECUTION,
            USER_PERMISSIONS.SUPPLY_PURCHASE_ORDER_ACCESS,
          ],
        },
        {
          icon: "bi bi-arrow-left-right",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.SUPPLY_TRANSFER_ORDERS"
          ),
          link: "supply-transfer-orders",
          role: [
            USER_PERMISSIONS.SUPPLY_EXECUTION,
            USER_PERMISSIONS.SUPPLY_TRANSFER_ORDERS_ACCESS,
          ],
        },
        {
          icon: "bi bi-box2",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.RECEPTION_ORDERS"
          ),
          link: "supply-reception-orders",
          role: [USER_PERMISSIONS.RECEPTION_ORDER_ACCESS],
        },
        {
          icon: "bi bi-card-list",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.SUPPLY_CONSIGNMENT_ORDERS"
          ),
          link: "supply-consignment-orders",
          role: [
            USER_PERMISSIONS.SUPPLY_EXECUTION,
            USER_PERMISSIONS.SUPPLY_TRANSFER_ORDERS_ACCESS,
          ],
        },
        {
          icon: "bi bi-calendar",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PRIORI_SCHEDULE"
          ),
          link: "priori-schedule-cd",
          role: [USER_PERMISSIONS.DC_PRIORI_SCHEDULE_ACCESS],
        },
      ],
    },
    {
      icon: "bi bi-currency-dollar",
      text: this.translateService.get(
        "DASHBOARD.VERTICAL_MENU.MENU.FINANCIAL_MANAGMENT"
      ),
      link: "financial-management",
      role: [
        USER_PERMISSIONS.FINANCIAL_ACCESS,
        USER_PERMISSIONS.AUDIT_ACCESS,
        USER_PERMISSIONS.CATMAN_PRICE_LIST_ACCESS,
        USER_PERMISSIONS.CATEGORIES_ACCESS,
      ],
      items: [
        {
          icon: "bi bi-card-checklist",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.FINANCE_PURCHASE_ORDERS"
          ),
          link: "financial-management",
          role: [USER_PERMISSIONS.FINANCIAL_ACCESS],
        },
        {
          icon: "bi bi-clipboard-check-fill",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.AUDIT_REPORT"
          ),
          link: "audit-report",
          role: [USER_PERMISSIONS.AUDIT_ACCESS],
        },
        {
          icon: "bi bi-person-lines-fill",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.REVIEW_PRICE_LIST"
          ),
          link: "catman-price-list",
          role: [USER_PERMISSIONS.CATMAN_PRICE_LIST_ACCESS],
        },
        {
          icon: "bi bi-collection-fill",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.CATEGORIES"
          ),
          link: "categories",
          role: [USER_PERMISSIONS.CATEGORIES_ACCESS],
        },
      ],
    },
    {
      icon: "bi bi-ticket-perforated",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.CAMPAIGNS"),
      role: [
        USER_PERMISSIONS.SUPPLY_EXECUTION,
        USER_PERMISSIONS.SUPPLY_INVENTORY_ACCESS,
        USER_PERMISSIONS.SUPPLY_TRANSFORMATIONS_ACCESS,
        USER_PERMISSIONS.CYCLICS_ACCESS,
      ],
      link: "campaigns",
    },
    {
      icon: "bi bi-pie-chart-fill",
      text: this.translateService.get(
        "DASHBOARD.VERTICAL_MENU.MENU.INDICATORS"
      ),
      role: [USER_PERMISSIONS.KPI_ACCESS],
      items: [
        {
          icon: "bi bi-clipboard2-data",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.SUPPLIER_METRICS"
          ),
          link: "kpis",
          role: [USER_PERMISSIONS.KPI_ACCESS],
        },
      ],
    },
    {
      icon: "bi bi-person-walking",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.OPERATION"),
      role: [
        USER_PERMISSIONS.PICKER_SCHEDULE_ACCESS,
        USER_PERMISSIONS.STORE_PRIORI_SCHEDULE_ACCESS,
      ],
      items: [
        {
          icon: "bi bi-calendar4-week",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PICKER_SCHEDULE"
          ),
          link: "picker-schedule",
          role: [USER_PERMISSIONS.PICKER_SCHEDULE_ACCESS],
        },
        {
          icon: "bi bi-calendar",
          text: this.translateService.get(
            "DASHBOARD.VERTICAL_MENU.MENU.PRIORI_SCHEDULE_SUPPLIER"
          ),
          link: "priori-schedule-store",
          role: [USER_PERMISSIONS.STORE_PRIORI_SCHEDULE_ACCESS],
        },
      ],
    },
  ];
  menuModules: Menu[] = [];
  menuAdministration: Menu[] = [
    {
      icon: "bi bi-people",
      text: this.translateService.get("DASHBOARD.VERTICAL_MENU.MENU.USERS"),
      link: "users",
      role: [USER_PERMISSIONS.EDIT_USER],
    },
    {
      icon: "bi bi-gear",
      text: this.translateService.get(
        "DASHBOARD.VERTICAL_MENU.MENU.PARAMETER_CONFIGURATION"
      ),
      link: "parameters",
      role: [USER_PERMISSIONS.PARAMETER_CONFIGURATION_ACCESS],
    },
  ];

  constructor(
    public authService: AuthService,
    private translateService: TranslateService,
    private router: Router,
    private readonly globalService: GlobalService
  ) {
    this.menuCollapse = false;
  }

  scrollToActiveMenuItem() {
    const elements = document.querySelectorAll(`[id^="'#collapse-'"]`);
    elements.forEach((element) => {
      element.classList.add("collapsed");
    });
    const url = window.location.href.split("/dashboard/");
    const firstElement = document.getElementById("'#collapse-' + 0");
    if (firstElement) {
      firstElement.classList.remove("expanded");
      const childFirstElement = document.getElementById("collapse-0");
      if (childFirstElement) {
        childFirstElement.classList.remove("show");
      }
    }
    let urlFinal = url[1]?.split(/[?/]/)[0];
    if (urlFinal !== "home") {
      const result = this.searchLinkInModules(this.menuModules, urlFinal)[0];
      if (result) {
        const indexToSearch = result.index;
        const indexSubItem = result.subItemIndex;
        const element = document.getElementById(
          `'#collapse-' + ${indexToSearch}`
        );
        if (element) {
          element.classList.remove("collapsed");
          element.scrollIntoView({ behavior: "smooth", block: "start" });
          element.classList.add("expanded");
          const child = document.getElementById(`collapse-${indexToSearch}`);
          if (child) {
            child.classList.add("show");
            if (!indexSubItem) {
              this.menuOptionSelected = true;
            }
          }
          if (indexSubItem !== undefined && indexSubItem !== null) {
            this.toggleDropdown(indexSubItem);
            this.menuOptionSelected = true;
          }
        }
      }
    } else {
      this.menuOptionSelected = true;
    }
  }

  public redirectToPage(): void {
    if (this.hasRedirected) return;
    const redirectToPageStorage = localStorage.getItem("redirect_to_page");
    if (redirectToPageStorage) {
      const redirectToPage: {
        redirect: boolean;
        url: string;
        queryParams?: any;
      } = JSON.parse(redirectToPageStorage);
      if (redirectToPage.redirect) {
        this.hasRedirected = true;
        localStorage.removeItem("redirect_to_page");
        this.router.navigate([redirectToPage.url], {
          queryParams: redirectToPage.queryParams,
        });
      }
    }
  }

  searchLinkInModules(menuItems, searchTerm) {
    const result = [];
    menuItems.forEach((item, index) => {
      if (item.link && typeof item.link === "string") {
        if (item.link === searchTerm) {
          result.push({ item, index });
        }
      }
      if (item.items && Array.isArray(item.items)) {
        item.items.forEach((subItem, subItemIndex) => {
          if (subItem.link && typeof subItem.link === "string") {
            if (subItem.link === searchTerm) {
              result.push({ item: subItem, index });
            }
          }
          if (subItem.subItems && Array.isArray(subItem.subItems)) {
            subItem.subItems.forEach((subSubItem) => {
              if (subSubItem.link && typeof subSubItem.link === "string") {
                if (subSubItem.link === searchTerm) {
                  result.push({ item: subSubItem, index, subItemIndex });
                }
              }
            });
          }
        });
      }
    });
    return result;
  }

  ngOnInit(): void {
    this.listMenuModules();
    this.listMenuAdministration();
    this.isVendor();
    this.knowIfAllSupplierHasAccessMetrics();
  }

  ngAfterViewChecked(): void {
    this.redirectToPage();
    const redirectToPageStorage = localStorage.getItem("redirect_to_page");
    if (!redirectToPageStorage && !this.menuOptionSelected) {
      this.scrollToActiveMenuItem();
    }
  }

  @HostListener("window:message", ["$event"])
  onMessage(event) {
    if (event.data.type === "COLLAPSE_LATERAL_MENU") {
      this.menuCollapse = event.data.data.value;
    }
  }

  toggleMenu() {
    this.menuCollapse = !this.menuCollapse;
  }

  logout() {
    localStorage.clear();
    this.authService.logout({
      logoutParams: { returnTo: window.location.origin },
    });
  }

  set usersHasAccessToModuleMetrics(value: boolean) {
    this._usersHasAccessToModuleMetrics = value;
    this.listMenuModules();
  }

  get usersHasAccessToModuleMetrics() {
    return this._usersHasAccessToModuleMetrics;
  }

  home() {
    window.location.pathname = "dashboard/home";
  }

  knowIfAllSupplierHasAccessMetrics() {
    const userData = JSON.parse(localStorage.getItem(localStorageKey)).user;
    const user_permissions = (userData?.permissions as string[]) || [];
    if (user_permissions.includes(USER_PERMISSIONS.SUPPLIER_ACCESS)) {
      this.globalService
        .getParameterValue(
          "TURBO-VENDORS-MS_ALL_SUPPLIER_HAS_ACCESS_METRICS_MODULE"
        )
        .subscribe((response) => {
          if (!response) {
            this.globalService
              .getParameterValue(
                "TURBO-VENDORS-MS_LIST_SUPPLIERS_WITH_ACCESS_METRICS_MODULE"
              )
              .subscribe((suppliersWithAccess) => {
                if (
                  !suppliersWithAccess.some((el) =>
                    userData.suppliers.includes(el)
                  )
                ) {
                  this.usersHasAccessToModuleMetrics = false;
                  this.listMenuModules(true);
                }
              });
          }
        });
      this.listMenuModules();
    }
  }

  checkPermission(roles) {
    const userData = JSON.parse(localStorage.getItem(localStorageKey)).user;
    const allowed = [...roles];
    const user_permissions = (userData?.permissions as string[]) || [];
    const validation = allowed.filter((p) => user_permissions.includes(p));
    return validation.length > 0;
  }

  checkPermissionVendor() {
    const userData = JSON.parse(localStorage.getItem(localStorageKey)).user;
    const user_permissions = (userData?.permissions as string[]) || [];
    if (user_permissions.length > 1) {
      return false;
    }
    return user_permissions.find((p) => p === USER_PERMISSIONS.SUPPLIER_ACCESS);
  }

  toggleDropdown(indexSubItem) {
    const dropdownMenu = document.getElementById(
      `content-sub-items-${indexSubItem}`
    ) as HTMLElement;
    const block = dropdownMenu.style.display === "block";
    dropdownMenu.style.display = block ? "none" : "block";
    let chevronSubMenuUp = document.querySelector(
      `.sub-menu-up-${indexSubItem}`
    ) as HTMLElement;
    chevronSubMenuUp.style.display = block ? "none" : "block";
    let chevronSubMenuDown = document.querySelector(
      `.sub-menu-down-${indexSubItem}`
    ) as HTMLElement;
    chevronSubMenuDown.style.display = block ? "block" : "none";
  }

  listMenuModules(noSupplierMetrics?: boolean) {
    const userData = JSON.parse(localStorage.getItem(localStorageKey)).user;
    const user_permissions = (userData?.permissions as string[]) || [];
    const menuToShow = user_permissions.includes(
      USER_PERMISSIONS.SUPPLIER_ACCESS
    )
      ? this.allMenuModulesSupplier
      : this.allMenuModules;

    this.menuModules = menuToShow
      .filter((module) => {
        return module.role.length === 0 || this.checkPermission(module.role);
      })
      .filter((menu) => {
        return (
          !menu.countriesEnable ||
          menu.countriesEnable.some((country) => country === environment.code)
        );
      });

    if (noSupplierMetrics) {
      this.menuModules = this.menuModules.filter(
        (module) => module.link !== "supplier-metrics"
      );
    }

    const filteredItems = this.menuModules.map((parent) => ({
      ...parent,
      items: parent.items?.filter(
        (item) =>
          !item.countriesEnable ||
          item.countriesEnable.some((country) => country === environment.code)
      ),
    }));
    this.menuModules = filteredItems;
  }

  listMenuAdministration() {
    this.menuAdministration.map((module) => {
      if (this.checkPermission(module.role)) {
        this.administrationMenu.push(module);
      }
    });
  }

  isVendor() {
    if (this.checkPermissionVendor()) {
      this.isVendorUser = true;
    }
  }
}
